export default {"src":"/_next/static/media/client-03.ecb20a54.svg","height":33,"width":107,"blurWidth":0,"blurHeight":0};